import { Image, Layout, Row, Col } from "antd";
import React, { useEffect, useState } from "react";
import { useMediaPredicate } from "react-media-hook";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import Burger from "../../components/layouts/HomeLayout/Burger";
import { useScroll } from "../../utils/useScroll";
import MobilityBanner from "../../assets/img/mobilitybanner.webp";
import Logo from "../../assets/img/logo-mobility.webp";
import Footer from "../../components/layouts/HomeLayout/Footer";
import GoogleMaps from "simple-react-google-maps";
import "./index.less";
import GoToTop from "../../components/GoToTop";
import { useDispatch, useSelector } from "react-redux";
import { getGamaLeasingBranchesContent } from "../../store/strapi/gamaleasing/thunks";
import {
  getBranchHeaderContent,
  getBranchesContent,
} from "../../store/strapi/gamaleasing";

function NewlineText(props) {
  const text = props?.text;
  return text ? text.split("\n").map((str) => <p key={str}>{str}</p>) : null;
}

function Branches() {
  const dispatch = useDispatch();
  const { scrollDirection } = useScroll();
  const biggerThan900 = useMediaPredicate("(min-width: 992px)");
  const biggerThan1300 = useMediaPredicate("(min-width: 1330px)");

  const [isSelected, setIsSelected] = useState(false);
  const [lat, setLat] = useState(-20.29029581647586);
  const [lng, setLng] = useState(-70.12517206441758);
  const [key, setKey] = useState("");
  const [branch, setBranch] = useState("IQUIQUE");

  const [isHome, setIsHome] = useState();

  useEffect(() => {
    dispatch(getGamaLeasingBranchesContent());
  }, []);

  const branchHeader = useSelector(getBranchHeaderContent);
  const branchSections = useSelector(getBranchesContent);

  useEffect(() => {
    if (window.location.pathname === "/branches") {
      setIsHome(false);
    } else {
      setIsHome(true);
    }
  }, [window.location.pathname]);

  const handleChangeMap = (branch) => {
    setLat(parseFloat(branch.lat));
    setLng(parseFloat(branch.lng));
    setKey(branch.branch);
    setBranch(branch.branch);
  };

  const [visible, setVisible] = useState(false);
  const styles = {
    active: {
      // visibility: "visible",
      transition: "all 0.2s ease-in-out",
    },
    hidden: {
      // visibility: "hidden",
      transition: "all 0.2s ease-in-out",
      transform: biggerThan900 && "translateY(-2.3rem)",
    },
  };

  const burguerData = [
    {
      title: "Sucursales",
      link: "/branches",
    },
    {
      title: "Nuestros servicios",
      link: "#services",
    },
    {
      title: "Quienes Somos",
      link: "#us",
    },
    { title: "Beneficios", link: "#benefits" },
    { title: "Publicaciones", link: "#posts" },
  ];

  const branches = [
    {
      branch: "IQUIQUE",
      calle: "Calle: Calle Vía 3, Sitio 11 S/N, Bajo Molle",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Ricardo Reyes",
      mail: "Mail: ricardo.reyes@gamaleasing.cl",
      telf: "Telf: 56 9 39186729",
      url: "https://goo.gl/maps/pLi4AyARJ9e9WwU98",
      boton: true,
      lat: "-20.29029581647586",
      lng: "-70.12517206441758",
    },
    {
      branch: "ANTOFAGASTA",
      calle: "Av. Pedro Aguirre Cerda 6100",
      serv: "Mecánica y mantenciones",
      contacto: "",
      mail: "contacto@gamaleasing.cl",
      telf: "+56 44 222 9975",
      url: "https://goo.gl/maps/EfTtespnaHiWT7XX8",
      boton: true,
      lat: "-23.59263083910367",
      lng: "-70.38961449815369",
    },

    {
      branch: "CALAMA",
      calle: "Ecuador 2194",
      serv: "Mecánica y mantenciones",
      contacto: "Nelson Barría",
      mail: " nelson.barria@gamaleasing.cl",
      telf: "56 9 42315922",
      url: "https://goo.gl/maps/bZXpsgfCSv7Y4KnR8",
      boton: true,
      lat: "-22.46833120766253",
      lng: "-68.92784693437414",
    },
    {
      branch: "COPIAPO",
      calle: "Pan. Norte 3604 Km 813 Megacentro 3 of 2",
      serv: "Mecánica y mantenciones",
      contacto: "Italo Condore",
      mail: "italo.condore@gamaleasing.cl",
      telf: "56 9 42315915",
      url: "https://goo.gl/maps/xjqP6RumPM9Y5Yty8",
      boton: true,
      lat: "-27.336782460475597",
      lng: "-70.37696729375517",
    },

    {
      branch: "SALAMANCA",
      calle: "Bernardo O’Higgins # 398",
      serv: "Mecánica y mantenciones",
      contacto: "Francisco Cortes",
      mail: "francisco.cortes@gamaleasing.cl",
      telf: "56 9 67796103",
      url: "https://goo.gl/maps/ZLQAwSt6jQtQAzc48",
      boton: true,
      lat: "-31.786775924528154",
      lng: "-71.02216433312348",
    },
    {
      branch: "CONCEPCION",
      calle: "Independencia 1270",
      serv: "Mecánica y mantenciones",
      contacto: "Raul Arevalo",
      mail: "raul.arevalo@gamaleasing.cl",
      telf: "56 9 7306 1438",
      url: "https://goo.gl/maps/E9dwoF9Svns1BVdg9",
      boton: true,
      lat: "-36.804621031001545",
      lng: "-73.0572454522671",
    },
    {
      branch: "TEMUCO",
      calle: "Caupolicán 1625, Cautín",
      serv: "Mecánica y mantenciones",
      contacto: "Fabián Delgado",
      mail: "patricio.delgado@gamaleasing.cl",
      telf: "56 9 42315921",
      url: "https://goo.gl/maps/ULaxBCWXEuaGhLE68",
      boton: true,
      lat: "-38.72556192808997",
      lng: "-72.57574358097509",
    },
    {
      branch: "VALDIVIA",
      calle: "Ecuador 2053",
      serv: "Mecánica y mantenciones",
      contacto: "Mauricio Carrasco",
      mail: "mauricio.carrasco@gamaleasing.cl",
      telf: "56 9 33818248",
      url: "https://goo.gl/maps/9hrcQVTCp66fXoNx6",
      boton: true,
      lat: "-39.82503938864901",
      lng: "-73.22285059606217",
    },
    {
      branch: "SANTIAGO",
      calle: "Américo Vespucio Nte. 1300, 9031241 Pudahuel.",
      serv: "Oficinas centrales",
      mail: "contacto@gamaleasing.cl",
      telf: "+56 44 222 9975",
      url: "https://goo.gl/maps/JPR14XKHjYRXyCFV9",
      boton: true,
      lat: "-33.426407130223005",
      lng: "-70.78489471349444",
    },
  ];

  const asociatedBranches = [
    {
      branch: "ARICA",
      nombre: "Neumatrix",
      calle: "Calle: Diego Portales 2556",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Scarlett Pinares",
      mail: "Mail: entasneumatrix@gmail.com",
      telf: "Telf: (58) 2583762",
      url: "https://goo.gl/maps/Qpr22C3wp4V3Duk38",
      boton: true,
      lat: "-18.487654582835635 ",
      lng: "-70.28817382514256",
    },
    {
      branch: "LA SERENA",
      nombre: "Tobero SPA",
      calle: "Calle: Cinco Nº 1251 locales 9 A y 9 B, Coquimbo",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Juan Andres Torrealba Munizaga",
      mail: "Mail: jatorrealbam@gmail.com",
      telf: "Telf: 56 9 99820636",
      url: "https://goo.gl/maps/QiMyLL39ygFSrB98A",
      boton: true,
      lat: "-29.968766986631138",
      lng: " -71.26581904219395",
    },
    {
      branch: "LOS ANDES",
      nombre: "MF Motores",
      calle: "Calle: Latorre 1316, Santa María, San Felipe",
      serv: "Serv: Mecánica, mantenciones y neumáticos",
      contacto: "Contacto:  Mariano Flores",
      mail: "Mail: mariano.311@gmail.com",
      telf: "Telf: 56 9 87776119",
      url: "https://goo.gl/maps/ZEniL156jZVN2UZ66",
      boton: true,
      lat: "-32.74536394843569",
      lng: "-70.66090741839534 ",
    },
    {
      branch: "QUILLOTA",
      nombre: "Armec",
      calle: "Calle: Bulnes #1156",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Claudio Ossandón",
      mail: "Mail: cossandon@armec.cl",
      telf: "Telf: (33) 314598 - 08-3565198",
      url: "https://goo.gl/maps/SXbmJwCtj3DsQtyeA",
      boton: true,
      lat: "-32.889838474800804",
      lng: "-71.25285574199675",
    },
    {
      branch: "VIÑA DEL MAR",
      nombre: "Cruciani",
      calle: "Calle: Av. Uno Norte 3750 B",
      serv: "Serv: Mecánica y mantenciones (camiones)",
      contacto: "Contacto: Lorenzo Cruciani",
      mail: "Mail: servicios@cruciani.cl",
      telf: "Telf: 32-2855973/ 2849852",
      url: "https://goo.gl/maps/hpG1wMqNzWLozMgs5",
      boton: true,
      lat: "-33.03802826222594",
      lng: "-71.51701300228086",
    },
    {
      branch: "VIÑA DEL MAR",
      nombre: "MF Motores",
      calle: "Calle: Limache 3117",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Mariano Flores",
      mail: "Mail: mariano.31f@gmail.com",
      telf: "Telf: 56 9 87776119",
      url: "https://goo.gl/maps/zEs7qTbwZL8BPfwc7",
      boton: true,
      lat: "-33.039142139248035",
      lng: "-71.52382682457231",
    },
    {
      branch: "SAN ANTONIO",
      nombre: "Maxpro Chile",
      calle: "Calle: Av. Barros Luco N° 2620",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Pablo Suazo",
      mail: "Mail: psuazo@maxprochile.cl",
      telf: "Telf: (35) 284624",
      url: "https://goo.gl/maps/eNY7EsVuQmerv52P9",
      boton: true,
      lat: "-33.6010900173013",
      lng: "-71.6133408",
    },
    {
      branch: "RANCAGUA",
      nombre: "Automotriz OPM",
      calle: "Calle: San Martin 47",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Juan Olea Muñoz",
      mail: "Mail: opmmecanica@gmail.com",
      telf: "Telf: 56975872650",
      url: "https://goo.gl/maps/UEWYfYV6nAQQXpdV7",
      boton: true,
      lat: "-34.165431737283704",
      lng: "-70.74561855357351",
    },
    {
      branch: "RANCAGUA",
      nombre: "Tecnología y color",
      calle: "Calle: Av. B. O’Higgins # 1061",
      serv: "Serv: Mecánica Desabolladura y Pintura",
      contacto: "Contacto: María Teresa Arjona",
      mail: "Mail: operaciones@tecnologiaycolor.cl",
      telf: "Telf: (72) 2240481 / 2211268",
      url: "https://goo.gl/maps/RL76ywhAzTeFFvN99",
      boton: true,
      lat: "-34.163383766692135",
      lng: "-70.7486372882142",
    },

    {
      branch: "CURICO",
      nombre: "Automotriz OPM",
      calle: "Calle: Avenida Rauquen N°3",
      serv: "Serv: Serv.: Mecánica y mantenciones",
      contacto: "Contacto: Juan Olea Muñoz",
      mail: "Mail: opmmecanica@gmail.com",
      telf: "Telf: 56 9 75872650",
      url: "https://goo.gl/maps/vZ7CaQZgcTEUqnqf9",
      boton: true,
      lat: "-34.975502004999335",
      lng: "-71.21326814175941",
    },
    {
      branch: "TALCA",
      nombre: "Automotriz Espinoza",
      calle: "Calle: 4 sur , 1 y 2 Oriente # 827 Talca",
      serv: "Serv: Mecánica, Desabolladura y Pintura",
      contacto: "Contacto: Rodrigo Espinoza",
      mail: "Mail: respinoza@automotrizespinoza.cl",
      telf: "Telf: 56 9 62755326",
      url: "https://goo.gl/maps/KsxDE4t6ngB4GR1i8",
      boton: true,
      lat: "-35.43041509461317",
      lng: "-71.66511767265014",
    },
    {
      branch: "TALCA",
      nombre: "Quelle",
      calle: "Calle: 9 Norte 1040",
      serv: "Serv: Mecánica, Desabolladura y Pintura",
      contacto: "Contacto: Pedro Vega",
      mail: "Mail: pvega@quelle.cl",
      telf: "Telf: 78632659",
      url: "https://goo.gl/maps/WtjEsx5bxx58Q7yL8",
      boton: true,
      lat: "-35.415562611015844",
      lng: "-71.66084756136301",
    },
    {
      branch: "CHILLAN",
      nombre: "Automotriz Chillán",
      calle: "Calle: Vera Suarez 91, Sector Estación",
      serv: "Serv: Mecánica, Desabolladura y Pintura",
      contacto: "Contacto: Claudio Guzmán",
      mail: "Mail: automotrizgyf@gmail.com",
      telf: "Telf: No disponible",
      url: "https://goo.gl/maps/EmhuYKR76oZ17U6T7",
      boton: true,
      lat: "-36.604753151065026",
      lng: "-72.11881197606571",
    },
    {
      branch: "LOS ANGELES",
      nombre: "Automotriz Chillán",
      calle: "Calle: Av. Gabriela Mistral 1255 Bod. 8",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Claudio Guzmán",
      mail: "Mail: automotrizgyf@gmail.com",
      telf: "Telf: No disponible",
      url: "https://goo.gl/maps/vybPK2hBTsuxVbGS8",
      boton: true,
      lat: "-37.47332442812037",
      lng: "-72.32850558281294",
    },
    {
      branch: "OSORNO",
      nombre: "Automotora Carrasco",
      calle: "Calle: Cesar Ercilla 726",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Guisella Carrasco",
      mail: "Mail: No disponible",
      telf: "Telf: No disponible",
      url: "https://g.page/automotoracarrasco?share",
      boton: true,
      lat: "-40.576498393344316",
      lng: "-73.11174762698889",
    },
    {
      branch: "PUERTO MONTT",
      nombre: "Mundo Automotriz",
      calle: "Calle: Calle Italia 1985, sector Cardonal",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Alejandro Mieville",
      mail: "Mail: tallermundoautomotriz@gmail.com",
      telf: "Telf: No disponible",
      url: "https://goo.gl/maps/fomuGJPKPCff3DXv8",
      boton: true,
      lat: "-41.46811583232116",
      lng: "-72.96815653309805",
    },
    {
      branch: "CHILOE",
      nombre: "Comercial Villaper",
      calle: "Calle: Llau-Llau s/n Castro",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Raúl Villarroel",
      mail: "Mail: tallervillaper@gmail.com",
      telf: "Telf: No disponible",
      url: "https://goo.gl/maps/cyZjRNEemUbt7yWf8",
      boton: true,
      lat: "-42.433415246375766",
      lng: "-73.76973649926012",
    },
    {
      branch: "COYHAIQUE",
      nombre: "Automotriz Varona",
      calle: "Calle: Carrera # 333",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Leonardo Solis",
      mail: "Mail: serviciotecnico@varona.cl",
      telf: "Telf: 56 9 95434458",
      url: "https://g.page/automotriz-varona?share",
      boton: true,
      lat: "-45.56836974250182",
      lng: "-72.06983729815369",
    },
    {
      branch: "PUNTA ARENAS",
      nombre: "Vm Cars",
      calle: "Calle: Carlos Bories 432",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Daniela Vargas",
      mail: "Mail: clientes@vmcars-automotriz.com",
      telf: "Telf: 61-2371342",
      url: "https://goo.gl/maps/6PTAP65UHskEaQW16",
      boton: true,
      lat: "-53.156427083108895",
      lng: "-70.90200296434976",
    },
    {
      branch: "SANTIAGO – TOBERO",
      calle:
        "Pdte. Jorge Alessandri Rodriguez 11.500 San Bernardo (Megacentro).      ",
      serv: "Serv: Mecánica y mantenciones",
      contacto: "Contacto: Yoel Anchil",
      mail: "Mail: yoel.anchil@gamaleasing.cl",
      telf: "Telf: 569 84484410",
      url: "https://goo.gl/maps/ZSbt7WTCQtdqP3xRA",
      boton: true,
      lat: "-33.55305120781452",
      lng: "-70.70799377287742",
    },
  ];
  return (
    <div>
      <GoToTop />
      <Layout>
        <section
          className="home-banner-container"
          id="header"
          style={{
            height: `70vh`,
          }}
        >
          <Row
            className="header-contain"
            style={{
              backgroundImage: `url(${
                branchHeader?.length === 0 || branchHeader === null
                  ? MobilityBanner
                  : branchHeader?.bannerImage?.data[0]?.attributes?.url
              })`,
            }}
          >
            <Col
              id="navbar"
              style={
                scrollDirection === "down" || !scrollDirection
                  ? styles.active
                  : styles.hidden
              }
            >
              <nav className="home-nav-container">
                <ul>
                  <li>
                    <a
                      target="_blank"
                      href={"https://gamamobility.cl/"}
                      rel="noreferrer"
                    >
                      GAMA MOBILITY
                    </a>
                  </li>
                  <li>
                    <Link
                      style={{
                        color:
                          window.location.pathname === "/"
                            ? "#FF3200"
                            : "white",
                      }}
                      to={"/"}
                    >
                      GAMA LEASING
                    </Link>
                  </li>

                  <li>
                    <a href={"https://www.gamarent.cl/"}>RENT A CAR</a>
                  </li>
                  <li>
                    <a href={"https://www.tripp.cl/"}>TRIPP</a>
                  </li>
                  <li>
                    <Link to={"/usados"}>GAMA USADOS</Link>
                  </li>
                </ul>
              </nav>
              <header>
                <div className="home-nav-items">
                  <div className="home-nav-logo">
                    <Link to={"/mobility"}>
                      <Image preview={false} src={Logo} width={120} />
                    </Link>
                  </div>
                  <div className="group-nav-items">
                    <div
                      className="nav-container-buttons"
                      style={{
                        transition: "all ease-out 1s;",
                        opacity: `${visible ? "0" : "1"}`,
                        pointerEvents: `${visible ? "none" : "auto"}`,
                      }}
                    >
                      <Link to="/contact">
                        <Button
                          onClick={() => {}}
                          className="gama-outline talk-button"
                        >
                          Conversemos
                        </Button>
                      </Link>
                    </div>
                    <div className="container-menu">
                      {biggerThan900 ? (
                        <div className="container-navlinks">
                          {isHome ? (
                            <>
                              <a smooth href="/branches">
                                Sucursales
                              </a>
                              <a smooth href="/mobility#services">
                                Nuestros Servicios
                              </a>
                              <a smooth href="/mobility#us">
                                Quienes Somos
                              </a>
                              <a smooth href="/mobility#benefits">
                                Beneficios
                              </a>
                              <a smooth href="/mobility#posts">
                                Publicaciones
                              </a>
                            </>
                          ) : (
                            <>
                              <Link to="/branches">Sucursales</Link>
                              <Link to="/mobility#services">
                                Nuestros Servicios
                              </Link>
                              <Link to="/mobility#us">Quienes Somos</Link>
                              <Link to="/mobility#benefits">Beneficios</Link>
                              <Link to="/mobility#posts">Publicaciones</Link>
                            </>
                          )}
                        </div>
                      ) : (
                        <Burger
                          data={burguerData}
                          modal={visible}
                          onClose={() => {
                            setVisible(!visible);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </header>
            </Col>
          </Row>
          <div className="banner-title-container">
            <h1
              style={{
                textAlign: "0",
                paddingLeft: "0",
              }}
            >
              {branchHeader?.length === 0 || branchHeader === null
                ? "Sucursales"
                : branchHeader?.title?.Title}
            </h1>
            <h3
              style={{
                textAlign: "",
                lineHeight: "35px",
                fontSize: "40px",
                fontWeight: "400",
                paddingLeft: "0",
              }}
            >
              {branchHeader?.length === 0 || branchHeader === null
                ? "Encuentra toda la información que necesitas acerca de nuestros talleres a lo largo del país."
                : branchHeader?.title?.Detail}
            </h3>

            <Row>
              <Button
                onClick={() => setIsSelected(false)}
                id="services"
                style={{ width: "11rem", marginTop: "1.5rem" }}
              >
                {branchSections?.length === 0 || branchSections === null
                  ? "Talleres Gama"
                  : branchSections?.Title01}
              </Button>

              <Button
                onClick={() => setIsSelected(true)}
                id="services"
                style={{
                  width: "11rem",
                  marginTop: "1.5rem",
                  marginLeft: "1.5rem",
                  backgroundColor: "black",
                  color: "white",
                  borderColor: "black",
                }}
              >
                {branchSections?.length === 0 || branchSections === null
                  ? "Talleres asociados"
                  : branchSections?.Title02}
              </Button>
            </Row>
          </div>
        </section>
      </Layout>
      <Row
        justify="start"
        style={{
          marginTop: "50px",
          marginLeft: biggerThan900 ? "150px" : "50px",
        }}
      >
        <p strong style={{ fontSize: "40px", fontWeight: "700" }}>
          {isSelected
            ? branchSections?.length === 0 || branchSections === null
              ? "Talleres Asociados"
              : branchSections?.Title02
            : branchSections?.length === 0
            ? "Talleres de Gama"
            : branchSections?.Title01}
        </p>
      </Row>
      <Row
        style={{
          width: "100%",
          paddingTop: "15px",
          paddingLeft: biggerThan1300 ? "100px" : "80px",
          marginBottom: "30px",
        }}
      >
        <Row style={{ width: biggerThan900 ? "60%" : "100%" }}>
          {branchSections?.length === 0 || branchSections === null
            ? !isSelected
              ? branches.map((branch) => (
                  <Row
                    key={branch.mail}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      width: biggerThan1300 ? "300px" : "200px",
                      lineHeight: "24px",
                    }}
                  >
                    <Col
                      onClick={() => handleChangeMap(branch)}
                      style={{
                        fontSize: "16px",
                        color: "#FF3200",
                        fontWeight: "700",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                    >
                      {branch.branch}
                    </Col>
                    <Col>{branch.name}</Col>
                    <Col>{branch.calle}</Col>
                    <Col>{branch.contacto}</Col>
                    <Col>{branch.mail}</Col>
                    <Col>{branch.telf}</Col>
                    <Col>{branch.serv}</Col>
                    <Row>
                      {branch.boton ? (
                        <a target="_blank" href={branch.url} rel="noreferrer">
                          <Button
                            style={{
                              width: "100px",
                              marginBottom: "70px",
                              marginTop: "10px",
                              borderRadius: "5px",
                            }}
                          >
                            Ir al Mapa
                          </Button>
                        </a>
                      ) : null}
                    </Row>
                  </Row>
                ))
              : asociatedBranches.map((branch) => (
                  <Row
                    key={branch.nombre}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      width: biggerThan1300 ? "300px" : "200px",
                      lineHeight: "24px",
                    }}
                  >
                    <Col
                      onClick={() => handleChangeMap(branch)}
                      style={{
                        fontSize: "16px",
                        color: "#FF3200",
                        fontWeight: "700",
                        marginBottom: "10px",
                        cursor: "pointer",
                      }}
                    >
                      {branch.branch}
                    </Col>
                    <Col>{branch.name}</Col>
                    <Col>{branch.calle}</Col>
                    <Col>{branch.contacto}</Col>
                    <Col>{branch.mail}</Col>
                    <Col>{branch.telf}</Col>
                    <Col>{branch.serv}</Col>
                    <Row>
                      {branch.boton ? (
                        <a target="_blank" href={branch.url} rel="noreferrer">
                          <Button
                            style={{
                              width: "100px",
                              marginBottom: "70px",
                              marginTop: "10px",
                              borderRadius: "5px",
                            }}
                          >
                            Ir al Mapa
                          </Button>
                        </a>
                      ) : null}
                    </Row>
                  </Row>
                ))
            : !isSelected
            ? branchSections?.GamaWorkshops?.map((branch) => (
                <Row
                  key={branch.Title}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: biggerThan1300 ? "300px" : "200px",
                    lineHeight: "24px",
                  }}
                >
                  <Col
                    onClick={() => handleChangeMap(branch)}
                    style={{
                      fontSize: "16px",
                      color: "#FF3200",
                      fontWeight: "700",
                      marginBottom: "10px",
                      cursor: "pointer",
                    }}
                  >
                    {branch.Title}
                  </Col>
                  <Col>
                    <NewlineText text={branch.Paragraph} />
                  </Col>
                  <Col>{branch.calle}</Col>
                  <Col>{branch.contacto}</Col>
                  <Col>{branch.mail}</Col>
                  <Col>{branch.telf}</Col>
                  <Col>{branch.serv}</Col>
                  <Row>
                    {branch?.Button?.Active === null ||
                    branch?.Button?.Active ? (
                      <a
                        target="_blank"
                        href={branch.Button.Hreference}
                        rel="noreferrer"
                      >
                        <Button
                          style={{
                            width: "100px",
                            marginBottom: "70px",
                            marginTop: "10px",
                            borderRadius: "5px",
                          }}
                        >
                          {branch.Button.Label
                            ? branch.Button.Label
                            : "Ir al Mapa"}
                        </Button>
                      </a>
                    ) : null}
                  </Row>
                </Row>
              ))
            : branchSections?.AssociatedWorkshops.map((branch) => (
                <Row
                  key={branch.Title}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: biggerThan1300 ? "300px" : "200px",
                    lineHeight: "24px",
                  }}
                >
                  <Col
                    onClick={() => handleChangeMap(branch)}
                    style={{
                      fontSize: "16px",
                      color: "#FF3200",
                      fontWeight: "700",
                      marginBottom: "10px",
                      cursor: "pointer",
                    }}
                  >
                    {branch.Title}
                  </Col>
                  <Col>
                    <NewlineText text={branch.Paragraph} />
                  </Col>
                  <Col>{branch.calle}</Col>
                  <Col>{branch.contacto}</Col>
                  <Col>{branch.mail}</Col>
                  <Col>{branch.telf}</Col>
                  <Col>{branch.serv}</Col>
                  <Row>
                    {branch?.Button?.Active === null ||
                    branch?.Button?.Active ? (
                      <a
                        target="_blank"
                        href={branch.Button.Hreference}
                        rel="noreferrer"
                      >
                        <Button
                          style={{
                            width: "100px",
                            marginBottom: "70px",
                            marginTop: "10px",
                            borderRadius: "5px",
                          }}
                        >
                          {branch.Button.Label
                            ? branch.Button.Label
                            : "Ir al Mapa"}
                        </Button>
                      </a>
                    ) : null}
                  </Row>
                </Row>
              ))}
        </Row>
        {biggerThan900 ? (
          <Row
            style={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#FF3200",
              height: "345px",
              width: "330px",
              borderRadius: "20px",
              top: "12%",
              position: "sticky",
            }}
          >
            <Row
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <svg
                style={{ width: "25px", height: "25px", color: "white" }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
                />
              </svg>
              <Row
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <Col
                  style={{
                    color: "white",
                    fontSize: "21px",
                    paddingTop: "5px",
                  }}
                >
                  {branch}
                </Col>
              </Row>
              <div>
                <GoogleMaps
                  key={key}
                  apiKey={process.env.REACT_APP_API_KEY_MAPS}
                  style={{ width: "300px", height: "300px" }}
                  zoom={14}
                  center={{
                    lat: lat,
                    lng: lng,
                  }}
                  markers={{ lat: lat, lng: lng }}
                />
              </div>
            </Row>
          </Row>
        ) : null}
      </Row>
      <Footer logo={Logo} />
    </div>
  );
}

export default Branches;
